/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActionResourceService} from "@well/resource-services";

@Injectable({
  providedIn: 'root'
})
export class ActionEditService {
  constructor(private actionResourceService: ActionResourceService) { }

  save(action: any): Observable<any> {
    return this.actionResourceService.update(action);
  }

  findOne(uuid: any){
    return this.actionResourceService.findOne(uuid);
  }

}
